import Controller from '@ember/controller';

import { ValueProposition } from '@repo/account-management-kit/components';

import { ConsentPageRoute } from 'register-partners-js/react/routes/consent/consent-page-route';

export default class WelcomeConsentController extends Controller {
  consentPageComponent = ConsentPageRoute;
  valueProposition = ValueProposition;
}
